var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"bi bi-circle icon-spinner status-icon text-info",staticStyle:{"clip-path":"polygon(0 0, 100% 0, 100% 50%, 0 50%)"}})}
var staticRenderFns = []

export { render, staticRenderFns }